<form [formGroup]="form" autocomplete="off" (submit)="onSubmit()">
  <mat-form-field appearance="outline" color="accent">
    <mat-label>{{ label }}</mat-label>
    <input matInput formControlName="searchQuery" />

    <div matSuffix class="flex">
      @if (searchQuery.value != '') {
        <button
          type="button"
          class="btn-icon"
          aria-label="Ryd søgning"
          matTooltip="Ryd søgning"
          (click)="resetSearchQuery()"
          >
          <mat-icon>close</mat-icon>
        </button>
      }
      <button type="submit" class="btn-icon" color="accent" [disabled]="$safeNavigationMigration(form?.invalid)" matTooltip="Søg">
        <mat-icon svgIcon="search"></mat-icon>
      </button>
    </div>
  </mat-form-field>
</form>
